import type { SourceEnum } from 'src/common/external/bambi-api/bambiApi';
import type { FilterPopoverProps } from 'src/common/primitives/FilterPopover/FilterPopover';
import { FilterPopoverTrigger } from 'src/common/primitives/FilterPopover/FilterPopoverTrigger';
import { MultiSelectFilterPopover } from 'src/common/primitives/FilterPopover/MultiSelectFilterPopover';

type IdentifiedSource = {
  id: SourceEnum;
  label: string;
};

// Extracts ID string from list
function unwrapSourceList(list: IdentifiedSource[]): SourceEnum[] {
  return list.map((s) => s.id);
}

function createIdentifiedList(list: SourceEnum[]) {
  return list.map((s) => ({
    id: s,
    label: sourceOptions.find((option) => option.id === s)?.label || '',
  }));
}

const sourceOptions: IdentifiedSource[] = [
  { id: 'pin', label: 'Pin' },
  { id: 'broker', label: 'Broker' },
  // { id: 'other', label: 'Other' }, This exists on the type but is not used yet
];

export default function SourceColumnFilter({
  selected,
  open,
  triggerElement,
  onApply,
  onClose,
}: {
  selected: SourceEnum[];
  open?: boolean;
  triggerElement?: FilterPopoverProps['triggerElement'];
  onApply: (sources: SourceEnum[]) => void;
  onClose?: () => void;
}) {
  return (
    <MultiSelectFilterPopover
      open={open}
      value={createIdentifiedList(selected)}
      filters={sourceOptions}
      renderLabel={(source) => source.label}
      triggerElement={
        triggerElement ?? (
          <FilterPopoverTrigger count={selected.length} label="Source" />
        )
      }
      onChange={(value) => {
        onApply(unwrapSourceList(value));
        onClose?.();
      }}
      onCancel={onClose}
    />
  );
}
